/**
 * API Fetcher Plugin
 * ============================================-
 */
import { get } from 'lodash'
import axios from 'axios'
import { wait } from '@/utils'
import getCookie from '@/utils/getCookie'
import { renameKeysToSnakeCase } from '@/utils/renameKeys'
import responseFilter from './responseFilter'

export { default as POST } from './POST'

/**
 * 共通インスタンス
 */
// dev実行時に固定トークンを保存
if (STAGE === STAGE_DEV) {
  document.cookie = 'csrf_cookie=84b5b91dbcf175e6abe0e22a8940a129'
}

const instance = axios.create({
  timeout: 50000,
  headers: {
    'X-CSRF-Token': getCookie('csrf_cookie'),
  },
})
instance.interceptors.response.use(undefined, err => err)

const multipartInstance = axios.create({
  timeout: 50000,
  headers: {
    'X-CSRF-Token': getCookie('csrf_cookie'),
    'content-type': 'multipart/form-data',
  },
})
multipartInstance.interceptors.response.use(undefined, err => err)

/**
 * API本体
 */
export default async ({ rootState: { stores } }, { url, params = {} }, options) => {
  params = renameKeysToSnakeCase(params)

  if (DEVELOPMENT) {
    // 開発モードの場合はリクエストバリデーション
    const err = options.validationSchema.validate(params, { allowUnknown: true }).error
    if (err) {
      const res = { data: { status: 2, message: err }, status: 400 }
      return responseFilter({ url, params }, res)
    }
  }

  if (params.store_id === undefined) {
    params.store_id = get(stores, 'current.store.id') || undefined
  } else if (params.store_id === null) {
    params.store_id = undefined
  }

  // local起動時はmockを返す
  if (STAGE === STAGE_LOCAL) {
    if (process.env.NODE_ENV !== 'test') console.log(url, params, options.mock)
    await wait(200)
    if (!options.mock) {
      return responseFilter({ url, params }, { response: { status: 404, data: { status: 0, message: 'Not Found' } } })
    }
    const status = options.mock.statusCode || 200
    const data = options.mock
    const obj = status === 200 ? { data, status } : { response: { data, status } }
    return responseFilter(
      { url, params },
      status !== 404 ? obj : { response: { status: 404, data: { status: 0, message: 'Not Found' } } },
    )
  }

  const res = await instance.post(url, params)
  return responseFilter({ url, params }, res)
}

export async function fileUploadApi({ rootState: { stores } }, { url, params = {} }, options) {
  if (DEVELOPMENT) {
    // 開発モードの場合はリクエストバリデーション
    const checkParams = {}
    Array(...params.entries()).forEach(item => {
      checkParams[item[0]] = item[1]
    })
    const err = options.validationSchema.validate(checkParams, { allowUnknown: true }).error
    if (err) {
      const res = { data: { status: 2, message: err }, status: 400 }
      return responseFilter({ url, params }, res)
    }
  }

  if (params.store_id === undefined) {
    params.append('store_id', get(stores, 'current.store.id') || undefined)
  } else if (params.store_id === null) {
    params.append('store_id', undefined)
  }

  // local起動時はmockを返す
  if (STAGE === STAGE_LOCAL) {
    if (process.env.NODE_ENV !== 'test') console.log(url, params, options.mock)
    await wait(200)
    if (!options.mock) {
      return responseFilter({ url, params }, { response: { status: 404, data: { status: 0, message: 'Not Found' } } })
    }
    const status = options.mock.statusCode || 200
    const data = options.mock
    const obj = status === 200 ? { data, status } : { response: { data, status } }
    return responseFilter(
      { url, params },
      status !== 404 ? obj : { response: { status: 404, data: { status: 0, message: 'Not Found' } } },
    )
  }

  const res = await multipartInstance.post(url, params)
  return responseFilter({ url, params }, res)
}
